module.exports = __webpack_public_path__ + "media/images/amenities_icons/ergonomic_chair-b0ac8e241ff359729638a35183d1e431.svg";